import React, { useState, useEffect, useCallback } from "react";

const useFetch = (url, options) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url) {
      return;
    }
    setLoading(true);
    fetch(url)
      .then((response) => {
        response.json().then((responseData) => {
          setData(responseData);
        });
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [url]);

  return { loading, data, error };
};

export default useFetch;
